<template>
	<div class="edit-org">
		<ep-title title="用户信息"></ep-title>
		<div class="u-form">
			<div class="u-p">
				<span>登录账号</span>
				<span>{{statelist.username}}</span>
			</div>
			<div class="u-p">
				<p class="u-emile" v-if='show_emily'>
					<span>邮箱</span>
					<span type="text">{{statelist.email}}</span>
					<i class="el-icon-edit" @click="change_emily">{{changeVal(statelist.email)}}</i>
				</p>
				<p class="u-emile" v-else>
					<span>邮箱</span>
					<el-input v-model="mod_emily" placeholder="请输入内容" style="width:200px"></el-input>
					<el-button type="primary" @click="sub_emily">提交</el-button>
					<el-button @click="close_emily">取消</el-button>
				</p>
			</div>
			<div class="u-p">
				<p class="u-name" v-if='show_name'>
					<span>姓名</span>
					<span type="text">{{statelist.name}}</span>
					<i class="el-icon-edit" @click="change_name">{{changeVal(statelist.name)}}</i>
				</p>
				<p class="u-emile" v-else>
					<span>姓名</span>
					<el-input v-model="mod_name" placeholder="请输入内容" style="width:200px"></el-input>
					<el-button type="primary" @click="sub_name">提交</el-button>
					<el-button @click="close_name">取消</el-button>
				</p>
			</div>
			<div class="u-p">
				<p class="u-name" v-if='show_job'>
					<span>职位</span>
					<span type="text">{{statelist.duty}}</span>
					<i class="el-icon-edit" @click="change_job">{{changeVal(statelist.duty)}}</i>
				</p>
				<p class="u-emile" v-else>
					<span>职位</span>
					<el-input v-model="mod_job" placeholder="请输入内容" style="width:200px"></el-input>
					<el-button type="primary" @click="sub_job">提交</el-button>
					<el-button @click="close_job">取消</el-button>
				</p>
			</div>
			<!--             <div class="u-p">
        <p class="u-name" v-if='show_branch'>
          <span>部门</span>
          <span type="text">{{statelist.orgName}}</span>
          <i class="el-icon-edit" @click="change_branch">{{changeVal(statelist.orgName)}}</i>
        </p>
        <p class="u-emile" v-else>
          <span>部门</span>
          <el-input v-model="mod_branch" placeholder="请输入内容" style="width:200px"></el-input>
          <el-button type="primary" @click="sub_branch">提交</el-button>
          <el-button @click="close_branch">取消</el-button>
        </p>
      </div> -->
			<div class="u-p">
				<p class="u-name" v-if='show_pwd'>
					<span>登录密码</span>
					<span type="text">建议您定期更换密码，设置的密码长度为8-20个字符，且至少包含1个大写字母，1个小写字母和1个数字，其他可以是任意字符</span>
					<i class="el-icon-edit" @click="change_pwd">修改</i>
				</p>
			</div>
			<div class="u-p">
				<span>微信</span>
				<span v-if="hasWechat">
                    {{this.statelist.wechatNickName}}&nbsp
                    <el-button type="primary" @click="unBindWechat" size="small">解除绑定</el-button>
                </span>
				<span v-else >
                    <el-button type="primary" @click="bindWechat" size="small">绑定</el-button>
                </span>
			</div>
			<div class="u-p">
				<p class="u-name">
					<span>
						<el-button type="primary" @click='changeCompany'>切换单位</el-button>
					</span>
				</p>
			</div>

		</div>

		<el-dialog title="切换申报单位" :visible.sync="dialogVisible" size="tiny">
			<div style="height:200px; overflow-y:auto" class="content-box">
				<ul class="content-con">
					<li v-for="(item,index) in detail" @click="liclick(item,index)" :key="index">
						<a :class="{active : selectIndex === index}">{{item.value}}</a>
					</li>
				</ul>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click='changeSure'>确定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
				title="绑定微信"
				:visible.sync="showQrCode"
				size="tiny">
                <span>绑定微信后，可实时收到备案事项提醒消息，以及系统更新公告等内容推送。
                    请尽快用微信扫码绑定您的账号。</span>
			<img class="qr-img" :src="qrCodeUrl"/>
			<!--<span slot="footer" class="dialog-footer">-->
			<!--<el-button @click="dialogVisible = false">取 消</el-button>-->
			<!--<el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
		</el-dialog>
	</div>
</template>
<script>
	import account from '../../data/ucenter/account.js'
	import company from '../../data/basic/plan/company.js'
	import { mapMutations, mapState } from 'vuex'
    import Wechat from '../../data/ucenter/wechat'


	export default {
		data() {
			return {
				// 显示的状态
				show_emily: true,
				show_name: true,
				show_job: true,
				show_pwd: true,
				show_branch: true,
				// 需要修改的字段
				mod_emily: '',
				mod_name: '',
				mod_job: '',
				mod_pwd: '',
				mod_branch: '',
				// 数据列表
				statelist: {
					address: '',
					duty: '',
					email: '',
					gender: '',
					isvalid: '',
					name: '',
					orgCode: '',
					orgName: '',
					qq: '',
					uid: '',
					utype: '',
                    openId: '',
                    wechatNickName: ''
				},
				dialogVisible: false,
				detail: [],
				currentSelCompony: null,
				selectIndex: -1,
                showQrCode:false,//显示二维码
                qrCodeUrl:'',//二维码地址
                hasWechat:false//是否绑定微信
			}
		},
		created() {
			this.profile()

		},
		methods: {
			...mapMutations(['changeIsRendering', 'setCurrentComponyName']),
            bindWechat(){
                (async() => {
                    try {
                        let param = {};
                        param.uid = this.statelist.uid;
                        let wechatState = await account.get_wechat_profile(param)
                        if(wechatState) {
                            this.$message({
                                message: '用户已经绑定过微信，请刷新页面',
                                type: 'warning'
                            });
                        }else {
                            this.getQrCode(this.statelist.uid);
                        }
                    } catch (error) {
                        console.log(error,"error")
                        this.$message.error('网络错误,请稍后重试')
                    }
                })()
            },
            unBindWechat(){
                this.$confirm('解除绑定后很多功能将无法使用，确认解除绑定吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.doUnBindWechat()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消绑定'
                    });
                });

            },
            doUnBindWechat(){
                (async() => {
                    try {
                        let param = {};
                        param.openId = this.statelist.openId;
                        let result = await account.unbind_wechat(param);
                        if (result.status === 0){
                            this.$message({
                                message: '解绑成功',
                                type: 'success'
                            });
                            this.hasWechat = false;
                            this.statelist.openId = '';
                            this.statelist.wechatNickName = '';
                        }
                    } catch (error) {
                        console.log(error,"error")
                        this.$message.error('网络错误,请稍后重试')
                    }
                })()
            },
            getQrCode(uid){
                (async() => {
                    try {
                        let param = {};
                        param.uid = uid;
                        let url = await Wechat.qrCodeUrl(param);
                        this.qrCodeUrl = url;
                        this.showQrCode = true;
                    } catch (error) {
                        console.log(error,"error")
                        this.$message.error('网络错误,请稍后重试')
                    }
                })()
            },
			// 切换单位
			changeCompany() {
				this.dialogVisible = true
				this.getData()
			},
			liclick(item, index) {
				this.currentSelCompony = item
				this.selectIndex = index
			},
			changeSure() {
				if(!this.currentSelCompony) {
					this.$message.error('请选择申报单位')
					return
				}
				sessionStorage.itemName = JSON.stringify(this.currentSelCompony)
				this.setCurrentComponyName(this.currentSelCompony)
				this.changeIsRendering(this.currentSelCompony.type)
				this.$router.push('/')
			},
			getData() {
				(async() => {
					let getState = await company.get_searchlist()
					if(getState.status) {
						let namalist = []
						let datalist = getState.data
						for(let i = 0; i < datalist.length; i++) {
							namalist.push({
								value: datalist[i].name,
								id: datalist[i].id,
								type: datalist[i].type
							})
						}
						this.detail = namalist
						sessionStorage.itemNamea = JSON.stringify(namalist)
					} else {
						this.$message.error(getState.msg)
					}
				})()
			},
			// 获取用户信息
			profile() {
				// (async() => {
				// 	this.statelist = await account.get_profile()
				// })()

                (async () => {
                    this.statelist = await account.get_profile();
                    // console.log(this.statelist, 'statelist');
                    // let user = JSON.parse(sessionStorage.allUser);
                    // console.log(user, 'user');
                    (async() => {
                        try {
                            let param = {};
                            param.uid = this.statelist.uid;
                            let wechatState = await account.get_wechat_profile(param)
                            if(wechatState) {
                                this.statelist.openId = wechatState.openId;
                                this.statelist.wechatNickName = wechatState.nickName;
                                // sessionStorage.allUser = JSON.stringify(user)
                                this.hasWechat = true;
                            }
                        } catch (error) {
                            console.log(error,"error")
                            this.$message.error('网络错误,请稍后重试')
                        }
                    })()
                })()
			},
			// 获取邮箱的值
			change_emily() {
				this.show_emily = false
				this.mod_emily = this.statelist.email
			},
			// 关闭修改邮箱
			close_emily() {
				this.show_emily = true
			},
			// 修改邮箱
			sub_emily() {
				(async() => {
					if(!this.mod_emily) {
						this.$message.error('邮箱不能为空')
						return
					}
					let isemily = await account.modify({
						uid: this.statelist.uid,
						email: this.mod_emily,
						name: this.statelist.name,
						duty: this.statelist.duty,
						orgName: this.statelist.orgName
					})
					if(isemily) {
						this.close_emily()
						this.statelist.email = this.mod_emily
						this.$message.success('修改邮箱成功')
					} else {
						this.$message.error('修改邮箱失败,请重试')
					}
				})()
			},
			// 获取名称的值
			change_name() {
				this.show_name = false
				this.mod_name = this.statelist.name
			},
			// 关闭修改名称
			close_name() {
				this.show_name = true
			},
			// 修改名称
			sub_name() {
				(async() => {
					if(!this.mod_name) {
						this.$message.error('名称不能为空')
						return
					}
					let isemily = await account.modify({
						uid: this.statelist.uid,
						name: this.mod_name,
						email: this.statelist.email,
						duty: this.statelist.duty,
						orgName: this.statelist.orgName
					})
					if(isemily) {
						this.close_name()
						this.statelist.name = this.mod_name
						this.$message.success('修改名称成功')
					} else {
						this.$message.error('修改名称失败,请重试')
					}
				})()
			},
			// 获取职位的值
			change_job() {
				this.show_job = false
				this.mod_job = this.statelist.duty
			},
			// 关闭修改职位
			close_job() {
				this.show_job = true
			},
			// 修改职位
			sub_job() {
				(async() => {
					if(!this.mod_job) {
						this.$message.error('职位不能为空')
						return
					}
					let isemily = await account.modify({
						uid: this.statelist.uid,
						duty: this.mod_job,
						name: this.statelist.name,
						email: this.statelist.email,
						orgName: this.statelist.orgName
					})
					if(isemily) {
						this.close_job()
						this.statelist.duty = this.mod_job
						this.$message.success('职位修改成功')
					} else {
						this.$message.error('职位修改失败,请重试')
					}
				})()
			},
			// 获取部门的值
			change_branch() {
				this.show_branch = false
				this.mod_branch = this.statelist.orgName
			},
			// 关闭修改部门
			close_branch() {
				this.show_branch = true
			},
			// 修改部门
			sub_branch() {
				(async() => {
					if(!this.mod_branch) {
						this.$message.error('部门不能为空')
						return
					}
					let isemily = await account.modify({
						uid: this.statelist.uid,
						orgName: this.mod_branch,
						name: this.statelist.name,
						email: this.statelist.email,
						duty: this.statelist.duty
					})
					if(isemily) {
						this.close_branch()
						this.statelist.orgName = this.mod_branch
						this.$message.success('部门修改成功')
					} else {
						this.$message.error('部门修改失败,请重试')
					}
				})()
			},
			// 获取密码的值
			change_pwd() {
				this.$router.push('/modpwd')
			},
			// 修改 添加
			changeVal(val) {
				return val && val.length > 1 ? '修改' : '添加'
			},
		}
	}
</script>
<style lang="stylus" scoped>
	.content-box {
		margin-top: -50px;
		li {
			list-style: none;
			height: 35px;
			line-height: 35px;
			width: 100%;
			font-size: 14px;
			cursor: pointer;
			list-style-type: none;
			a {
				text-indent: 10px;
				width: 100%;
				height: 100%;
				display: inline-block;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				transition: all .5s;
				&:hover,
				&.active {
					border-radius: 5px;
					width: 100%;
					background: rgba(0, 0, 0, .2);
					height: 100%;
					color: #000;
				}
			}
		}
	}

	.u-form {
		.u-p {
			font-size: 14px;
			line-height: 75px;
			height: 75px;
			border-bottom: 1px solid #eeeeee;
			padding-left: 50px;
			span:first-child {
				display: inline-block;
				width: 110px;
				text-align: right;
				margin-right: 40px;
				color: #666666;
				font-weight: bold;
			}
			span:nth-child(2) {
				cursor: pointer;
				display: inline-block;
				margin-right: 10px;
				color: #666666;
			}
		}
		.u-p:last-child {
			margin-bottom: 100px;
		}
	}

	.el-icon-edit {
		color: #359eff;
		cursor: pointer;
		margin-left: 5px;
		display: none;
		-webkit-transform: all .3s;
		-ms-transform: all .3s;
		-o-transform: all .3s;
		transform: all .3s;
		&:before {
			padding-right: 10px;
		}
	}

	.u-p:hover .el-icon-edit {
		display: inline-block;
	}

	.el-button+.el-button {
		margin-left: 0px;
	}

	.qr-img {
		width: 80%;
		height: 80%;
		margin-left: 10%;
	}
</style>



// WEBPACK FOOTER //
// User.vue?5d530bbc